
import React, { useEffect, useState } from 'react'
import { Routes, Route, Router, Link } from 'react-router-dom'
import Layout from '../components/Layout'
import RequireAuth from '../components/RequireAuth'
import { roles } from '../constants/Roles'
import Main from '../pages/Main'

import Login from '../pages/Login'
import Register from '../pages/Register'
import Profile from '../pages/Profile/Profile'
import ManageForm from '../pages/Forms/ManageForm'
import SingleForm from '../pages/Forms/SingleForm'
import Draggable from '../pages/Draggable'
import FormContext from '../context/FormContext'
import Responses from '../components/Responses/Responses'
import Responses_2 from '../components/Responses/Responses_2'
import AllUsers from '../pages/Users/AllUsers'
import { useSelector } from 'react-redux'
import ViewerForm from '../pages/Forms/ViewerForm'
import RequestForms from '../pages/Forms/RequestForms'
import CreateForm from '../pages/Forms/CreateForm'
import CreateAdmin from '../pages/Users/CreateAdmin'
import ForgotPassword from '../pages/ForgotPassword'
import ResetPassword from '../pages/ResetPassword'
import FormRequests from '../pages/Forms/FormRequests'
import Analytics from '../components/Responses/Analytics'
import ComingSoon from '../components/ComingSoon'

function RoutesPath() {
    const [role, setrole] = useState(null);
    const currRole = useSelector(state => state?.users)
    useEffect(() => {
        if (role == null)
            setrole(localStorage.getItem('shub-roles'))

    }, [role, currRole]);


    return (

        <Routes>
            <Route path="/" element={<Layout />} exact>

                <Route path="unauthorized" element={<>unauthorized</>} />
                <Route path="login" element={<Login />} />
                <Route path="register" element={<Register />} />
                <Route path="forms/:id" element={<ViewerForm />} />
                <Route path="forgot-password/:id" element={<ForgotPassword />} />
                <Route path="reset-password" element={<ResetPassword />} />
                <Route
                    element={
                        <RequireAuth
                            allowedRoles={[roles.SUPER_ADMIN, roles.ADMIN, roles.SURVEYOR]}
                        />
                    }
                >
                    <Route path="profile" element={<>profile</>} />
                </Route>

                <Route element={<RequireAuth allowedRoles={[roles.ADMIN, roles.SUPER_ADMIN, roles.SURVEYOR]} />} >
                    <Route path="dashboard" element={<Main role={role} />} >
                        <Route path="profile" element={<Profile role={role} />} />
                        <Route path="manage-form" element={<ManageForm />} />
                        <Route path="manage-form/:id" element={<SingleForm />} />
                        <Route path="manage-form/:id" element={<SingleForm />} >
                            <Route path="view" element={<SingleForm />} />
                            <Route path="edit" element={<SingleForm />} />
                            <Route path="responses" element={<Responses_2 />} />
                            <Route path="summary" element={<Responses />} />
                            <Route path="analytics" element={<ComingSoon />} />
                        </Route>

                    </Route>
                </Route>

                <Route element={<RequireAuth allowedRoles={[roles.SUPER_ADMIN, roles.ADMIN]} />}>
                    <Route path="dashboard" element={<Main role={role} />} >
                        <Route path="create-form" element={<CreateForm />} />
                        <Route path="manage-form" element={<ManageForm />} />
                        <Route path="manage-form/:id" element={<SingleForm />} />
                        <Route path="manage-form/:id" element={<SingleForm />} >
                            <Route path="questions" element={<Draggable />} />
                        </Route>
                    </Route>
                </Route>


                <Route element={<RequireAuth allowedRoles={[roles.SUPER_ADMIN]} />}>
                    <Route path="dashboard" element={<Main role={role} />} >
                        <Route path="create-admins" element={<CreateAdmin />} />
                        <Route path="manage-admins" element={<AllUsers />} />
                        <Route path="form-requests" element={<FormRequests />} />
                        {/* <Route path="manage-form" element={<>manage form</>} /> */}

                    </Route>
                </Route>


                <Route element={<RequireAuth allowedRoles={[roles.ADMIN]} />}>
                    <Route path="dashboard" element={<Main role={role} />} >
                        <Route path="create-form" element={<CreateForm />} />
                        {/* <Route path="manage-form" element={<>manage form</>} /> */}
                    </Route>
                </Route>
                <Route element={<RequireAuth allowedRoles={[roles.SURVEYOR]} />}>
                    <Route path="dashboard" element={<Main role={role} />} >
                        <Route path="request-form" element={<RequestForms />} />
                        <Route path="manage-form/:id" element={<SingleForm />} />
                        <Route path="manage-form/:id/view" element={<SingleForm />} />
                    </Route>
                </Route>
                <Route path="*" element={<>404 not found</>} />
            </Route>
        </Routes >

    )
}

export default RoutesPath